/**
 * created by xcc
 表单子项
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Input} from "antd";

export default class RmtText extends Component {
    static defaultProps = {
        type: "text",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        let {field, onChange} = this.props;
        onChange(field, window.currentUser.name);
    }

    componentDidMount() {
    }

    render() {
        let {value, disabled, field, onChange, formItemSizeConfig, id} = this.props;
        return <Input
            id={id}
            size={formItemSizeConfig.inputSize || 'default'}
            placeholder={`请输入`}
            disabled={disabled}
            value={value}
            onChange={(e) => {
                let val = e.target.value || '';
                onChange(field, val)
            }}
        />
    }
}